import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import { Message, Button, Divider } from 'semantic-ui-react';
import { withFormik } from 'formik';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import queryString from 'query-string';
import { AuthClient /* , log */ } from '@emyw/core-lib';
import { normalizeErrors } from '../utils';
import '../primitives.css';
const ValidateEmailLogic = withFormik({
  validateOnBlur: false,
  validateOnChange: false,
  // Transform outer props into form values
  mapPropsToValues: () => ({
    email: ''
  }),
  // Submission handler
  handleSubmit: async (values, _ref) => {
    let {
      props: {
        mutate,
        props,
        user,
        onValidated
      },
      setErrors,
      setStatus,
      setSubmitting,
      setFieldValue
    } = _ref;
    // get the reset token from the url
    const verifyToken = queryString.parse(props.location.search).t;
    if (!verifyToken) {
      setStatus('noLink');
    } else {
      setStatus('validatingLink');
      setSubmitting(false);
      const response = await mutate({
        variables: {
          userId: user.id,
          verifyToken
        }
      });
      const {
        ok,
        email,
        errors
      } = response.data.validateEmailLink;
      if (ok) {
        setFieldValue('email', email);
        setStatus('validLink');
        // log.trace(onValidated);
        if (onValidated) onValidated();else log.warn('onValidated prop required but not provided');
      } else {
        setStatus('invalidLink');
        setErrors(normalizeErrors(errors));
      }
    }
  }
});
let submitted = false;

/** Verify Email Form is used after a user has requested a change to their email to validate that they actually receive
 * email at the new address.
 * <br /><br /><hr /><br />
 * <div>
 * <h4>Back-end Requirements</h4>
 * A backend graphql api endpoint with the validateEmailLink mutation,
 * <a rel=noopener href="https://github.com/emyw/auth-api">auth-api</a>,
 * is needed for this form to function.
 * <h4>Verify Email</h4>
 * Whenever the system needs to verify that the user's email is valid, an email will be sent to the address
 * with a link to this private route form for them to verify. Since this form is meant to be in a PrivateRoute,
 * it will require the user to authenticate before the link is validated.
 * </div>
 */
const ValidateEmailForm = _ref2 => {
  let {
    submitForm,
    status,
    values,
    errors,
    onOkClicked,
    onTryAgainClicked,
    forceStatus
  } = _ref2;
  // when initializing the page, first we will validate the update link code
  const localStatus = !status ? forceStatus : status;
  if (!localStatus && values.email === '' && !submitted) {
    submitted = true;
    submitForm();
  }
  return /*#__PURE__*/React.createElement("div", null, (localStatus === '' || localStatus === 'validatingLink') && /*#__PURE__*/React.createElement("div", null, "Processing Link. One moment please..."), (localStatus === 'noLink' || localStatus === 'invalidLink') && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
    attached: "top"
  }, /*#__PURE__*/React.createElement(Message.Header, null, "Expired or invalid link")), /*#__PURE__*/React.createElement(Message, {
    attached: "bottom"
  }, errors.email && /*#__PURE__*/React.createElement(React.Fragment, null, "Oops. Something went wrong:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Message, {
    size: "mini",
    error: true
  }, errors.email.indexOf('unique') ? 'This email is already in use by another account.' : errors.email), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  })), errors.verifyToken && /*#__PURE__*/React.createElement(React.Fragment, null, "Oops. Something went wrong:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Message, {
    size: "mini",
    error: true
  }, errors.verifyToken), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  })), !errors.verifyToken && !errors.email && /*#__PURE__*/React.createElement(React.Fragment, null, "Oops. Something went wrong. Perhaps it took too long for the verification link to be used from when it was issued.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
    className: "orButtons"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    basic: true,
    color: "blue",
    fluid: true,
    onClick: () => {
      if (onTryAgainClicked) onTryAgainClicked();else log.warn('onTryAgainClicked prop required but not provided');
    }
  }, "Try Again"), /*#__PURE__*/React.createElement("span", {
    className: "orDividerVertical"
  }, "- OR -"), /*#__PURE__*/React.createElement(Divider, {
    horizontal: true,
    className: "orDividerHorizontal"
  }, "OR"), /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      if (onOkClicked) onOkClicked();else log.warn('onOkClicked prop required but not provided');
    },
    basic: true,
    color: "grey",
    fluid: true
  }, "Home Page")))), localStatus === 'validLink' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
    attached: "top"
  }, /*#__PURE__*/React.createElement(Message.Header, null, "Success!")), /*#__PURE__*/React.createElement(Message, {
    attached: "bottom"
  }, "Your new email ", values.email ? " ".concat(values.email) : '', " has been verified.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    color: "blue",
    fluid: true,
    basic: true,
    onClick: () => {
      if (onOkClicked) onOkClicked();else log.warn('onOkClicked prop required but not provided');
    }
  }, "OK"))));
};
const validateEmailLinkMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($userId: Int!, $verifyToken: String!) {\n        validateEmailLink(userId: $userId, verifyToken: $verifyToken) {\n            ok\n            email\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
ValidateEmailForm.defaultProps = {
  forceStatus: undefined
};
export default compose(graphql(validateEmailLinkMutation, {
  client: AuthClient
}), ValidateEmailLogic)(ValidateEmailForm);